<app-view-recepit *ngIf="!view_invoice"></app-view-recepit>

<app-view-invoice *ngIf="view_invoice"></app-view-invoice>